require('./aggregatorAddEntityStepLogin.scss')

const { FormattedText, formatText } = require('core/i18n').i18n;

import PropTypes from 'prop-types';
import React from 'react';

import { AggregatorAddEntityStepLoginForm } from './aggregatorAddEntityStepLoginForm'
import { AggregatorBeta } from 'components/aggregator/aggregatorBeta/aggregatorBeta';

import { recordLink, PROC_AGGREGATOR, PROC_SELECT_ENTITY } from 'utilities/tagging';

const infoIcon = require('assets/images/info-icon.png');

class AggregatorAddEntityStepLogin extends React.PureComponent {

    componentWillMount() {
        const { bankUniqueId, getDataBank, mustLoadBankData } = this.props;

        getDataBank && mustLoadBankData && getDataBank(bankUniqueId)
    }

    componentDidMount() {
        const { name } = this.props

        recordLink(PROC_AGGREGATOR, PROC_SELECT_ENTITY, name)
    }

    buildForm = () => {
        const { form, setFormValue, isFetching, values, clearFormValues } = this.props

        return (
            <AggregatorAddEntityStepLoginForm
                form={form}
                clearFormValues={clearFormValues}
                setFormValue={setFormValue}
                isFetching={isFetching}
                values={values}
            />
        )
    }


    renderInfo = () => {
        const { bankId, name } = this.props
        if (!["Caixabank", "Banc Sabadell"].includes(bankId))
            return null

        return (
            <section className="aggregator-add-entity__wizard__wizard-step-login__head__info-box">
                <div className="aggregator-add-entity__wizard__wizard-step-login__head__info-box__header">
                    <div className="aggregator-add-entity__wizard__wizard-step-login__head__info-box__header__info-icon">
                        <img src={infoIcon} alt={formatText('aggregatorAddEntity-infoNoInvestmentmentsAlt', [name])}/>
                    </div>
                    <div className="aggregator-add-entity__wizard__wizard-step-login__head__info-box__header__info-text">
                        <FormattedText className="" value="aggregatorAddEntity-infoNoInvestmentmentsText" injectedStrings={[name]} />
                    </div>
                </div>
            </section>
        )
    }

    render() {
        const { url, name, showDisclaimer, beta } = this.props

        return (
            <div className="aggregator-add-entity__wizard__wizard-step-login">
                <div className="aggregator-add-entity__wizard__wizard-step-login__head">
                    <img className="aggregator-add-entity__wizard__wizard-step-login__head__img" src={url} />
                    {beta && <AggregatorBeta tooltipTextKey="aggregatorBeta-selectBankTooltip"/>}
                </div>
                <div className="aggregator-add-entity__wizard__wizard-step-login__form">
                    <div className="aggregator-add-entity__wizard__wizard-step-login__form__text">
                        <FormattedText value="aggregatorAddEntity-formText" injectedStrings={[name]} />
                    </div>
                    {this.renderInfo()}
                    <div className="aggregator-add-entity__wizard__wizard-step-login__form__form">
                        {this.buildForm()}
                    </div>
                    {
                        showDisclaimer &&
                        <div className="aggregator-add-entity__wizard__wizard-step-login__disclaimer">
                            <div className="aggregator-add-entity__wizard__wizard-step-login__disclaimer__inner">
                                <div className="aggregator-add-entity__wizard__wizard-step-login__disclaimer__inner__div">
                                    <i className="aggregator-add-entity__wizard__wizard-step-login__disclaimer__inner__icon icon icon-informacion"></i>
                                    <FormattedText className="aggregator-add-entity__wizard__wizard-step-login__disclaimer__inner__text" value="aggregatorAddEntity-disclaimer" />
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

AggregatorAddEntityStepLogin.propTypes = {
    name: PropTypes.string,
    beta: PropTypes.bool,
    url: PropTypes.string,
    bankId: PropTypes.string,
    getDataBank: PropTypes.func,
    form: PropTypes.object,
    isFetching: PropTypes.bool,
    setFormValue: PropTypes.func,
    values: PropTypes.object,
    showDisclaimer: PropTypes.bool,
    clearFormValues: PropTypes.func,
    bankUniqueId: PropTypes.string,
    mustLoadBankData: PropTypes.bool,
}

AggregatorAddEntityStepLogin.defaultProps = {
    showDisclaimer: true,
    mustLoadBankData: false,
}

export { AggregatorAddEntityStepLogin }